import { UseFormReturn } from 'react-hook-form';
import { AxiosResponse } from 'axios';
import useToast from 'hooks/useToast';
import { useQRScreenNavigation } from 'hooks/navigation/useQRSCreenNavigation';
import { InfoCollectionFormType } from '../types';
import { useSaveInfoMutation } from '../api/mutations';
import { useQRStore } from '../store/useQRStore';
import { useQRFlow } from './useQRFlow';

export const useInfoCollection = (
  methods: UseFormReturn<InfoCollectionFormType>,
) => {
  const { getValues, trigger, reset } = methods;
  const { mobileNumber, setUserDetail } = useQRStore();
  const toast = useToast();
  const { goToGuestUserDetail } = useQRScreenNavigation();
  const { setItemsToLocalStorage } = useQRFlow();

  const { mutate: saveInfo, isPending: isSaveInfoLoading } =
    useSaveInfoMutation();

  const handleSaveInfo = async () => {
    const isValid = await trigger();
    if (isValid) {
      const values = getValues();
      const payload = {
        phone_number: mobileNumber,
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
        company: values.company ?? '',
      };
      saveInfo(payload, {
        onSuccess: (res: AxiosResponse) => {
          const responseMessage = res.data.message;
          toast.success(responseMessage ?? 'Info saved successfully');
          setItemsToLocalStorage(res?.data);
          setUserDetail(res?.data?.user_detail);
          reset();
          goToGuestUserDetail();
        },
        onError: (error) => {
          const errorMessage = (error.response?.data as { message: string })
            ?.message;
          toast.error(errorMessage ?? 'Something went wrong');
        },
      });
    }
  };
  return { handleSaveInfo, isSaveInfoLoading };
};
